define('Designrequest.ei1.Main.View', [
    'SCView',
    'design_request.tpl',
    'Designrequest.ei1.Main.Model'
], function (
    SCViewComponent,
    design_request_tpl,
    DesignrequestModel
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    // Total number of phases in the wizard. This tracks how many phases
    // are actually BUILT so far, not the final design - Proof is the
    // last planned phase, so this stays 4 going forward.
    var TOTAL_PHASES = 4;

    // Delivery by is restricted to "today through N days from today" -
    // both the date picker's min/max attributes AND the format
    // validation below use this same constant, and it's mirrored
    // server-side in the Suitelet as a backstop.
    var DELIVERY_MAX_WEEKS_AHEAD = 3;

    // ----- PHASE 1: DESIGN - list internal IDs -----
    var OTHER_PRODUCT_TYPE_ID = '10';
    var NEED_TYPE_REDESIGN_ID = '2';
    // customlist_style_direction_list
    var STYLE_DIRECTION_YES_ID = '1';

    // ----- PHASE 2: PRINT - list internal IDs -----
    // customlist_wants_prints_list
    var WANTS_PRINT_YES_ID = '1';

    // ----- PHASE 4: PROOF - list internal IDs -----
    // customlist_want_delivery_list
    var WANTS_DELIVERY_YES_ID = '1';

    // ----- PHASE 3: INFO - format validation -----
    // Loose on purpose - these exist to catch obviously-malformed input
    // (e.g. "22353532dgeg3") before it ever reaches the Suitelet, not to
    // fully replicate RFC 5322 / E.164 validation.
    var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var PHONE_REGEX = /^[0-9()+\-.\s]{7,20}$/;

    // Maps each formData key to the NetSuite field-meta key returned by
    // the Suitelet (so we can read isMandatory) and to the .form-group's
    // data-group attribute (so we know which element to flag as invalid).
    // 'type' controls how "is this filled in" is checked. 'phase'
    // controls which wizard phase this field belongs to, so
    // validateForm() only checks fields on the phase currently visible.
    // 'condition(formData)' decides whether the field is even applicable
    // given the user's other answers on THAT SAME phase - if it returns
    // false, the field is skipped (not required, and expected to be
    // hidden in the template).
    var FIELD_VALIDATION_CONFIG = [

        // ----- PHASE 1: DESIGN -----
        {
            formKey: 'needType', metaKey: 'needType', group: 'needType', type: 'select', phase: 1,
            condition: function () { return true; }
        },
        {
            formKey: 'productType', metaKey: 'productType', group: 'productType', type: 'radio', phase: 1,
            condition: function (fd) { return fd.needType !== NEED_TYPE_REDESIGN_ID; }
        },
        {
            formKey: 'brandPersonality', metaKey: 'brandPersonality', group: 'brandPersonality', type: 'radio', phase: 1,
            condition: function (fd) { return fd.needType !== NEED_TYPE_REDESIGN_ID; }
        },
        {
            formKey: 'styleDirection', metaKey: 'styleDirection', group: 'styleDirection', type: 'radio', phase: 1,
            condition: function (fd) { return fd.needType !== NEED_TYPE_REDESIGN_ID; }
        },
        {
            formKey: 'styleReference', metaKey: 'styleReference', group: 'styleReference', type: 'text', phase: 1,
            condition: function (fd) {
                return fd.needType !== NEED_TYPE_REDESIGN_ID && fd.styleDirection === STYLE_DIRECTION_YES_ID;
            }
        },
        {
            formKey: 'preferredColors', metaKey: 'preferredColors', group: 'preferredColors', type: 'text', phase: 1,
            condition: function (fd) { return fd.needType !== NEED_TYPE_REDESIGN_ID; }
        },
        {
            formKey: 'preferredFonts', metaKey: 'preferredFonts', group: 'preferredFonts', type: 'text', phase: 1,
            condition: function (fd) { return fd.needType !== NEED_TYPE_REDESIGN_ID; }
        },
        {
            formKey: 'competitors', metaKey: 'competitors', group: 'competitors', type: 'text', phase: 1,
            condition: function (fd) { return fd.needType !== NEED_TYPE_REDESIGN_ID; }
        },
        {
            formKey: 'sampleFile', metaKey: 'sampleUpload', group: 'sampleUpload', type: 'file', phase: 1,
            condition: function () { return true; }
        },
        {
            formKey: 'staySame', metaKey: 'staySame', group: 'staySame', type: 'text', phase: 1,
            condition: function (fd) { return fd.needType === NEED_TYPE_REDESIGN_ID; }
        },
        {
            formKey: 'mustChange', metaKey: 'mustChange', group: 'mustChange', type: 'text', phase: 1,
            condition: function (fd) { return fd.needType === NEED_TYPE_REDESIGN_ID; }
        },

        // ----- PHASE 2: PRINT -----
        {
            formKey: 'wantsPrint', metaKey: 'wantsPrint', group: 'wantsPrint', type: 'radio', phase: 2,
            condition: function () { return true; }
        },
        {
            formKey: 'printProductType', metaKey: 'printProductType', group: 'printProductType', type: 'select', phase: 2,
            condition: function (fd) { return fd.wantsPrint === WANTS_PRINT_YES_ID; }
        },
        {
            formKey: 'printQuantity', metaKey: 'printQuantity', group: 'printQuantity', type: 'text', phase: 2,
            condition: function (fd) { return fd.wantsPrint === WANTS_PRINT_YES_ID; }
        },
        {
            formKey: 'printSize', metaKey: 'printSize', group: 'printSize', type: 'select', phase: 2,
            condition: function (fd) { return fd.wantsPrint === WANTS_PRINT_YES_ID; }
        },
        {
            formKey: 'printPaper', metaKey: 'printPaper', group: 'printPaper', type: 'select', phase: 2,
            condition: function (fd) { return fd.wantsPrint === WANTS_PRINT_YES_ID; }
        },
        {
            formKey: 'printColorMode', metaKey: 'printColorMode', group: 'printColorMode', type: 'select', phase: 2,
            condition: function (fd) { return fd.wantsPrint === WANTS_PRINT_YES_ID; }
        },
        {
            formKey: 'printFinish', metaKey: 'printFinish', group: 'printFinish', type: 'select', phase: 2,
            condition: function (fd) { return fd.wantsPrint === WANTS_PRINT_YES_ID; }
        },

        // ----- PHASE 3: INFO -----
        {
            formKey: 'infoName', metaKey: 'infoName', group: 'infoName', type: 'text', phase: 3,
            condition: function () { return true; },
            requiredMessage: 'This field is required.'
        },
        {
            formKey: 'infoEmail', metaKey: 'infoEmail', group: 'infoEmail', type: 'text', phase: 3,
            condition: function () { return true; },
            requiredMessage: 'This field is required.',
            formatTest: function (value) { return EMAIL_REGEX.test(value); },
            formatMessage: 'Please enter a valid email address.'
        },
        {
            formKey: 'infoPhone', metaKey: 'infoPhone', group: 'infoPhone', type: 'text', phase: 3,
            condition: function () { return true; },
            requiredMessage: 'This field is required.',
            formatTest: function (value) { return PHONE_REGEX.test(value); },
            formatMessage: 'Please enter a valid phone number.'
        },
        {
            formKey: 'infoComments', metaKey: 'infoComments', group: 'infoComments', type: 'text', phase: 3,
            condition: function () { return true; },
            requiredMessage: 'This field is required.'
        },

        // ----- PHASE 4: PROOF -----
        {
            formKey: 'proofDelivery', metaKey: 'proofDelivery', group: 'proofDelivery', type: 'radio', phase: 4,
            condition: function (fd) { return fd.wantsPrint === WANTS_PRINT_YES_ID; },
            requiredMessage: 'Please select one option.'
        },
        {
            formKey: 'disclaimerDigitalProof', metaKey: 'disclaimerDigitalProof', group: 'disclaimerDigitalProof', type: 'checkbox', phase: 4,
            condition: function (fd) { return fd.wantsPrint === WANTS_PRINT_YES_ID; },
            mustBeTrue: true,
            requiredMessage: 'You must agree to this before continuing.'
        },
        {
            formKey: 'disclaimerScreenColors', metaKey: 'disclaimerScreenColors', group: 'disclaimerScreenColors', type: 'checkbox', phase: 4,
            condition: function (fd) { return fd.wantsPrint === WANTS_PRINT_YES_ID; },
            mustBeTrue: true,
            requiredMessage: 'You must agree to this before continuing.'
        },
        {
            formKey: 'wantsDelivery', metaKey: 'wantsDelivery', group: 'wantsDelivery', type: 'select', phase: 4,
            condition: function (fd) { return fd.wantsPrint === WANTS_PRINT_YES_ID; },
            requiredMessage: 'This field is required.'
        },
        {
            formKey: 'courierPartner', metaKey: 'courierPartner', group: 'courierPartner', type: 'radio', phase: 4,
            condition: function (fd) {
                return fd.wantsPrint === WANTS_PRINT_YES_ID && fd.wantsDelivery === WANTS_DELIVERY_YES_ID;
            },
            requiredMessage: 'Please select one option.'
        },
        {
            formKey: 'shippingSpeed', metaKey: 'shippingSpeed', group: 'shippingSpeed', type: 'radio', phase: 4,
            condition: function (fd) {
                return fd.wantsPrint === WANTS_PRINT_YES_ID && fd.wantsDelivery === WANTS_DELIVERY_YES_ID;
            },
            requiredMessage: 'Please select one option.'
        },
        {
            formKey: 'deliveryAddress', metaKey: 'deliveryAddress', group: 'deliveryAddress', type: 'text', phase: 4,
            condition: function (fd) {
                return fd.wantsPrint === WANTS_PRINT_YES_ID && fd.wantsDelivery === WANTS_DELIVERY_YES_ID;
            },
            requiredMessage: 'This field is required.'
        },
        {
            formKey: 'designFilesApproval', metaKey: 'designFilesApproval', group: 'designFilesApproval', type: 'checkbox', phase: 4,
            condition: function (fd) { return fd.wantsPrint !== WANTS_PRINT_YES_ID; },
            mustBeTrue: true,
            requiredMessage: 'You must agree to this before continuing.'
        },
        {
            formKey: 'disclaimerFinalApproval', metaKey: 'disclaimerFinalApproval', group: 'disclaimerFinalApproval', type: 'checkbox', phase: 4,
            condition: function () { return true; },
            mustBeTrue: true,
            requiredMessage: 'You must agree to this before continuing.'
        },
        {
            formKey: 'disclaimerNonRefundable', metaKey: 'disclaimerNonRefundable', group: 'disclaimerNonRefundable', type: 'checkbox', phase: 4,
            condition: function () { return true; },
            mustBeTrue: true,
            requiredMessage: 'You must agree to this before continuing.'
        },
        {
            formKey: 'deliveryBy', metaKey: 'deliveryBy', group: 'deliveryBy', type: 'text', phase: 4,
            condition: function () { return true; },
            requiredMessage: 'This field is required.',
            formatTest: isDeliveryDateInRange,
            formatMessage: getDeliveryDateRangeMessage
        }
    ];

    function _updateSteps(currentPhase) {
        document.querySelectorAll('.design-request-wizard__steps li').forEach((li, index) => {
            const stepNumber = index + 1;
            li.classList.remove('is-active', 'is-completed');
            if (stepNumber < currentPhase) {
                li.classList.add('is-completed');
            } else if (stepNumber === currentPhase) {
                li.classList.add('is-active');
            }
        });
    }

    function isEmptyValue(type, value) {
        if (type === 'file') {
            return !value;
        }
        if (type === 'checkbox') {
            return value !== true;
        }
        return value === undefined || value === null || String(value).trim() === '';
    }

    function pad2(n) {
        return n < 10 ? '0' + n : String(n);
    }

    function formatDateForInput(d) {
        return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
    }

    var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'];

    function formatDateForDisplay(d) {
        return MONTH_NAMES[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    }

    function getDeliveryDateRangeMessage() {
        var bounds = getDeliveryDateBounds();
        return 'Please choose a date between ' + formatDateForDisplay(bounds.min) +
            ' and ' + formatDateForDisplay(bounds.max) +
            ' (today through the next ' + DELIVERY_MAX_WEEKS_AHEAD + ' weeks).';
    }

    function getDeliveryDateBounds() {
        var today = new Date();
        today.setHours(0, 0, 0, 0);

        var max = new Date(today);
        max.setDate(max.getDate() + (DELIVERY_MAX_WEEKS_AHEAD * 7));

        return { min: today, max: max };
    }

    function isDeliveryDateInRange(dateString) {
        if (isEmptyValue('text', dateString)) { return true; }

        var year, month, day;
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            var isoParts = dateString.split('-');
            year = Number(isoParts[0]); month = Number(isoParts[1]) - 1; day = Number(isoParts[2]);
        } else if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
            var usParts = dateString.split('/');
            month = Number(usParts[0]) - 1; day = Number(usParts[1]); year = Number(usParts[2]);
        } else {
            return false;
        }

        var picked = new Date(year, month, day);
        if (isNaN(picked.getTime())) { return false; }

        var bounds = getDeliveryDateBounds();
        return picked.getTime() >= bounds.min.getTime() && picked.getTime() <= bounds.max.getTime();
    }

    function resolveSelectField(meta) {
        var options = (meta && meta.options) || [];
        var defaultValue = meta ? meta.defaultValue : '';
        var matchIndex = -1;

        options.forEach(function (opt, idx) {
            if (defaultValue && opt.value === defaultValue) { matchIndex = idx; }
        });
        if (matchIndex === -1 && options.length) { matchIndex = 0; }

        var mappedOptions = options.map(function (opt, idx) {
            return { value: opt.value, text: opt.text, isSelected: idx === matchIndex };
        });

        return {
            options: mappedOptions,
            seededValue: matchIndex > -1 ? options[matchIndex].value : ''
        };
    }

    function resolveRadioField(meta, forcedDefaultValue) {
        var options = (meta && meta.options) || [];
        var defaultValue = forcedDefaultValue || (meta ? meta.defaultValue : '');
        var matchIndex = -1;

        options.forEach(function (opt, idx) {
            if (defaultValue && opt.value === defaultValue) { matchIndex = idx; }
        });
        if (matchIndex === -1 && options.length) { matchIndex = 0; }

        var mappedOptions = options.map(function (opt, idx) {
            return { value: opt.value, text: opt.text, isChecked: idx === matchIndex };
        });

        return {
            options: mappedOptions,
            seededValue: matchIndex > -1 ? options[matchIndex].value : ''
        };
    }

    var self = null;

    // ===== CONSTRUCTOR =====
    // Fetches field meta immediately on construction (no framework
    // lifecycle hook needed/relied upon) - self.render() only fires once
    // the fetch resolves, so getContext() always has real fieldMeta by
    // the time the template first renders.
    function DesignrequestMainView(options) {
        SCView.call(this);
        self = this;
        self.options = options || {};
        self.template = design_request_tpl;

        self.model = new DesignrequestModel();
        self.currentPhase = 1;
        self.fieldMeta = null;
        self.formData = {
            // ----- PHASE 1: DESIGN -----
            needType: '',
            productType: '',
            productTypeOther: '',
            brandPersonality: '',
            styleDirection: '',
            styleReference: '',
            preferredColors: '',
            preferredFonts: '',
            competitors: '',
            staySame: '',
            mustChange: '',
            sampleFile: null,

            // ----- PHASE 2: PRINT -----
            wantsPrint: '',
            printProductType: '',
            printQuantity: '1',
            printSize: '',
            printPaper: '',
            printColorMode: '',
            printFinish: '',

            // ----- PHASE 3: INFO -----
            infoName: '',
            infoEmail: '',
            infoPhone: '',
            infoComments: '',

            // ----- PHASE 4: PROOF -----
            proofDelivery: '',
            disclaimerDigitalProof: false,
            disclaimerScreenColors: false,
            disclaimerFinalApproval: false,
            disclaimerNonRefundable: false,
            wantsDelivery: '',
            courierPartner: '',
            shippingSpeed: '',
            deliveryAddress: '',
            deliveryBy: '',
            designFilesApproval: false
        };

        console.log('[DesignRequest] constructor - fetching field meta...');
        self.model.fetch().then(function () {
            console.log('[DesignRequest] fetch resolved, rendering');
            self.render();
        }).catch(function (error) {
            console.error('[DesignRequest] fetch FAILED:', error);
            self.render();
        });
    }

    DesignrequestMainView.prototype = Object.create(SCView.prototype);
    DesignrequestMainView.prototype.constructor = DesignrequestMainView;

    // Re-fetch then re-render - not called automatically by anything,
    // available if the parent ever needs to force a refresh.
    DesignrequestMainView.prototype.reRender = function () {
        self.model.fetch().then(function () {
            self.render();
        });
    };

    DesignrequestMainView.prototype.getEvents = function () {
        return {
            // ----- PHASE 1: DESIGN -----
            'change .js-need-type': 'onNeedTypeChange',
            'change .js-product-type': 'onProductTypeChange',
            'change .js-product-type-other': 'onFieldChange',
            'change .js-brand-personality': 'onFieldChange',
            'change .js-style-direction': 'onStyleDirectionChange',
            'change .js-style-reference': 'onFieldChange',
            'change .js-preferred-colors': 'onFieldChange',
            'change .js-preferred-fonts': 'onFieldChange',
            'change .js-competitors': 'onFieldChange',
            'change .js-stay-same': 'onFieldChange',
            'change .js-must-change': 'onFieldChange',
            'change .js-sample-upload': 'onFileSelected',

            // ----- PHASE 2: PRINT -----
            'change .js-wants-print': 'onWantsPrintChange',
            'change .js-print-product-type': 'onFieldChange',
            'change .js-print-quantity': 'onFieldChange',
            'change .js-print-size': 'onFieldChange',
            'change .js-print-paper': 'onFieldChange',
            'change .js-print-color-mode': 'onFieldChange',
            'change .js-print-finish': 'onFieldChange',

            // ----- PHASE 3: INFO -----
            'change .js-info-name': 'onFieldChange',
            'change .js-info-email': 'onFieldChange',
            'change .js-info-phone': 'onFieldChange',
            'change .js-info-comments': 'onFieldChange',

            // ----- PHASE 4: PROOF -----
            'change .js-proof-delivery': 'onFieldChange',
            'change .js-disclaimer-digital-proof': 'onCheckboxFieldChange',
            'change .js-disclaimer-screen-colors': 'onCheckboxFieldChange',
            'change .js-disclaimer-final-approval': 'onCheckboxFieldChange',
            'change .js-disclaimer-non-refundable': 'onCheckboxFieldChange',
            'change .js-wants-delivery': 'onWantsDeliveryChange',
            'change .js-courier-partner': 'onFieldChange',
            'change .js-shipping-speed': 'onFieldChange',
            'change .js-delivery-address': 'onFieldChange',
            'change .js-delivery-by': 'onDeliveryByChange',
            'change .js-design-files-approval': 'onCheckboxFieldChange',

            // ----- WIZARD NAVIGATION -----
            'click [data-action="previous-phase"]': 'onPreviousClick',
            'click [data-action="next-phase"]': 'onNextClick',

            // ----- SUBMIT RESULT MODALS -----
            'click .js-success-modal-close': 'onSuccessModalClose',
            'click .js-error-modal-close': 'onErrorModalClose'
        };
    };

    DesignrequestMainView.prototype.getContext = function () {
        console.log('[DesignRequest] getContext() called, model data:', self.model.toJSON());
        var response = self.model.toJSON();
        var fields = (response && response.data) ? response.data : {};

        self.fieldMeta = fields;

        // ----- PHASE 1: DESIGN -----
        var needTypeResolved = resolveSelectField(fields.needType);
        if (!self.formData.needType) { self.formData.needType = needTypeResolved.seededValue; }

        // ----- PHASE 2: PRINT -----
        var wantsPrintResolved = resolveRadioField(fields.wantsPrint, WANTS_PRINT_YES_ID);
        if (!self.formData.wantsPrint) { self.formData.wantsPrint = wantsPrintResolved.seededValue; }

        var printProductTypeResolved = resolveSelectField(fields.printProductType);
        if (!self.formData.printProductType) { self.formData.printProductType = printProductTypeResolved.seededValue; }

        var printSizeResolved = resolveSelectField(fields.printSize);
        if (!self.formData.printSize) { self.formData.printSize = printSizeResolved.seededValue; }

        var printPaperResolved = resolveSelectField(fields.printPaper);
        if (!self.formData.printPaper) { self.formData.printPaper = printPaperResolved.seededValue; }

        var printColorModeResolved = resolveSelectField(fields.printColorMode);
        if (!self.formData.printColorMode) { self.formData.printColorMode = printColorModeResolved.seededValue; }

        var printFinishResolved = resolveSelectField(fields.printFinish);
        if (!self.formData.printFinish) { self.formData.printFinish = printFinishResolved.seededValue; }

        // ----- PHASE 4: PROOF -----
        var proofDeliveryResolved = resolveRadioField(fields.proofDelivery);
        if (!self.formData.proofDelivery) { self.formData.proofDelivery = proofDeliveryResolved.seededValue; }

        var wantsDeliveryResolved = resolveSelectField(fields.wantsDelivery);
        if (!self.formData.wantsDelivery) { self.formData.wantsDelivery = wantsDeliveryResolved.seededValue; }

        var courierPartnerResolved = resolveRadioField(fields.courierPartner);
        if (!self.formData.courierPartner) { self.formData.courierPartner = courierPartnerResolved.seededValue; }

        var shippingSpeedResolved = resolveRadioField(fields.shippingSpeed);
        if (!self.formData.shippingSpeed) { self.formData.shippingSpeed = shippingSpeedResolved.seededValue; }

        return {

            // ----- PHASE 1: DESIGN -----
            needTypeLabel: fields.needType ? fields.needType.label : '',
            needTypeOptions: needTypeResolved.options,
            needTypeMandatory: !!(fields.needType && fields.needType.isMandatory),

            productTypeLabel: fields.productType ? fields.productType.label : '',
            productTypeOptions: fields.productType ? fields.productType.options : [],
            productTypeMandatory: !!(fields.productType && fields.productType.isMandatory),

            productTypeOtherLabel: fields.productTypeOther ? fields.productTypeOther.label : '',

            brandPersonalityLabel: fields.brandPersonality ? fields.brandPersonality.label : '',
            brandPersonalityOptions: fields.brandPersonality ? fields.brandPersonality.options : [],
            brandPersonalityMandatory: !!(fields.brandPersonality && fields.brandPersonality.isMandatory),

            styleDirectionLabel: fields.styleDirection ? fields.styleDirection.label : '',
            styleDirectionOptions: fields.styleDirection ? fields.styleDirection.options : [],
            styleDirectionMandatory: !!(fields.styleDirection && fields.styleDirection.isMandatory),

            styleReferenceLabel: fields.styleReference ? fields.styleReference.label : '',

            preferredColorsLabel: fields.preferredColors ? fields.preferredColors.label : '',
            preferredFontsLabel: fields.preferredFonts ? fields.preferredFonts.label : '',
            competitorsLabel: fields.competitors ? fields.competitors.label : '',

            sampleUploadLabel: fields.sampleUpload ? fields.sampleUpload.label : '',
            sampleUploadMandatory: !!(fields.sampleUpload && fields.sampleUpload.isMandatory),

            staySameLabel: fields.staySame ? fields.staySame.label : '',
            staySameMandatory: !!(fields.staySame && fields.staySame.isMandatory),

            mustChangeLabel: fields.mustChange ? fields.mustChange.label : '',
            mustChangeMandatory: !!(fields.mustChange && fields.mustChange.isMandatory),

            // ----- PHASE 2: PRINT -----
            wantsPrintLabel: fields.wantsPrint ? fields.wantsPrint.label : '',
            wantsPrintOptions: wantsPrintResolved.options,
            wantsPrintMandatory: !!(fields.wantsPrint && fields.wantsPrint.isMandatory),

            printProductTypeLabel: fields.printProductType ? fields.printProductType.label : '',
            printProductTypeOptions: printProductTypeResolved.options,
            printProductTypeMandatory: !!(fields.printProductType && fields.printProductType.isMandatory),

            printQuantityLabel: fields.printQuantity ? fields.printQuantity.label : '',
            printQuantityMandatory: !!(fields.printQuantity && fields.printQuantity.isMandatory),

            printSizeLabel: fields.printSize ? fields.printSize.label : '',
            printSizeOptions: printSizeResolved.options,
            printSizeMandatory: !!(fields.printSize && fields.printSize.isMandatory),

            printPaperLabel: fields.printPaper ? fields.printPaper.label : '',
            printPaperOptions: printPaperResolved.options,
            printPaperMandatory: !!(fields.printPaper && fields.printPaper.isMandatory),

            printColorModeLabel: fields.printColorMode ? fields.printColorMode.label : '',
            printColorModeOptions: printColorModeResolved.options,
            printColorModeMandatory: !!(fields.printColorMode && fields.printColorMode.isMandatory),

            printFinishLabel: fields.printFinish ? fields.printFinish.label : '',
            printFinishOptions: printFinishResolved.options,
            printFinishMandatory: !!(fields.printFinish && fields.printFinish.isMandatory),

            // ----- PHASE 3: INFO -----
            infoNameLabel: fields.infoName ? fields.infoName.label : '',
            infoNameMandatory: !!(fields.infoName && fields.infoName.isMandatory),

            infoEmailLabel: fields.infoEmail ? fields.infoEmail.label : '',
            infoEmailMandatory: !!(fields.infoEmail && fields.infoEmail.isMandatory),

            infoPhoneLabel: fields.infoPhone ? fields.infoPhone.label : '',
            infoPhoneMandatory: !!(fields.infoPhone && fields.infoPhone.isMandatory),

            infoCommentsLabel: fields.infoComments ? fields.infoComments.label : '',
            infoCommentsMandatory: !!(fields.infoComments && fields.infoComments.isMandatory),

            // ----- PHASE 4: PROOF -----
            proofDeliveryLabel: fields.proofDelivery ? fields.proofDelivery.label : '',
            proofDeliveryOptions: proofDeliveryResolved.options,
            proofDeliveryMandatory: !!(fields.proofDelivery && fields.proofDelivery.isMandatory),

            disclaimerDigitalProofLabel: fields.disclaimerDigitalProof ? fields.disclaimerDigitalProof.label : '',
            disclaimerScreenColorsLabel: fields.disclaimerScreenColors ? fields.disclaimerScreenColors.label : '',
            disclaimerFinalApprovalLabel: fields.disclaimerFinalApproval ? fields.disclaimerFinalApproval.label : '',
            disclaimerNonRefundableLabel: fields.disclaimerNonRefundable ? fields.disclaimerNonRefundable.label : '',

            wantsDeliveryLabel: fields.wantsDelivery ? fields.wantsDelivery.label : '',
            wantsDeliveryOptions: wantsDeliveryResolved.options,
            wantsDeliveryMandatory: !!(fields.wantsDelivery && fields.wantsDelivery.isMandatory),

            courierPartnerLabel: fields.courierPartner ? fields.courierPartner.label : '',
            courierPartnerOptions: courierPartnerResolved.options,
            courierPartnerMandatory: !!(fields.courierPartner && fields.courierPartner.isMandatory),

            shippingSpeedLabel: fields.shippingSpeed ? fields.shippingSpeed.label : '',
            shippingSpeedOptions: shippingSpeedResolved.options,
            shippingSpeedMandatory: !!(fields.shippingSpeed && fields.shippingSpeed.isMandatory),

            deliveryAddressLabel: fields.deliveryAddress ? fields.deliveryAddress.label : '',
            deliveryAddressMandatory: !!(fields.deliveryAddress && fields.deliveryAddress.isMandatory),

            deliveryByLabel: fields.deliveryBy ? fields.deliveryBy.label : '',
            deliveryByMandatory: !!(fields.deliveryBy && fields.deliveryBy.isMandatory),

            designFilesApprovalLabel: fields.designFilesApproval ? fields.designFilesApproval.label : '',

            isFirstPhase: self.currentPhase === 1,
            isLastPhase: self.currentPhase === TOTAL_PHASES,

            selected: self.formData
        };
    };

    DesignrequestMainView.prototype.onFieldChange = function (e) {
        var $el = self.$(e.currentTarget);
        var field = $el.data('field');
        self.formData[field] = $el.val();
        console.log('[DesignRequest] field changed:', field, '=', $el.val());
        self._clearFieldError(field);
    };

    DesignrequestMainView.prototype.onCheckboxFieldChange = function (e) {
        var $el = self.$(e.currentTarget);
        var field = $el.data('field');
        self.formData[field] = $el.is(':checked');
        console.log('[DesignRequest] checkbox changed:', field, '=', self.formData[field]);
        self._clearFieldError(field);
    };

    // ===== PHASE 1: DESIGN =====

    DesignrequestMainView.prototype.onNeedTypeChange = function (e) {
        var $el = self.$(e.currentTarget);
        var value = $el.val();
        self.formData.needType = value;
        console.log('[DesignRequest] needType changed =', value);
        self._clearFieldError('needType');
        self._applyNeedTypeVisibility(value);
    };

    DesignrequestMainView.prototype._applyNeedTypeVisibility = function (value) {
        var isRedesign = value === NEED_TYPE_REDESIGN_ID;

        self.$('.js-new-design-group').toggleClass('hidden', isRedesign);
        self.$('.js-redesign-group').toggleClass('hidden', !isRedesign);
        self._syncProductTypeOtherVisibility();
        self._syncStyleReferenceVisibility();

        var groupsToClear = isRedesign
            ? ['productType', 'brandPersonality', 'styleDirection', 'preferredColors', 'preferredFonts', 'competitors', 'productTypeOther', 'styleReference']
            : ['staySame', 'mustChange'];
        groupsToClear.forEach(function (group) {
            self._clearGroupError(group);
        });
    };

    DesignrequestMainView.prototype._syncProductTypeOtherVisibility = function () {
        var isRedesign = self.formData.needType === NEED_TYPE_REDESIGN_ID;
        var isOtherSelected = self.formData.productType === OTHER_PRODUCT_TYPE_ID;
        self.$('.js-product-type-other-wrapper').toggleClass('hidden', isRedesign || !isOtherSelected);
    };

    DesignrequestMainView.prototype.onStyleDirectionChange = function (e) {
        var $el = self.$(e.currentTarget);
        var value = $el.val();
        self.formData.styleDirection = value;
        self._clearFieldError('styleDirection');
        self._syncStyleReferenceVisibility();
    };

    DesignrequestMainView.prototype._syncStyleReferenceVisibility = function () {
        var isRedesign = self.formData.needType === NEED_TYPE_REDESIGN_ID;
        var wantsReference = self.formData.styleDirection === STYLE_DIRECTION_YES_ID;
        var shouldHide = isRedesign || !wantsReference;
        self.$('.js-style-reference-wrapper').toggleClass('hidden', shouldHide);
        if (shouldHide) {
            self._clearGroupError('styleReference');
        }
    };

    DesignrequestMainView.prototype.onProductTypeChange = function (e) {
        var $el = self.$(e.currentTarget);
        var value = $el.val();
        self.formData.productType = value;
        self._clearFieldError('productType');

        self._syncProductTypeOtherVisibility();
        if (value !== OTHER_PRODUCT_TYPE_ID) {
            self._clearGroupError('productTypeOther');
        }
    };

    DesignrequestMainView.prototype.onFileSelected = function (e) {
        var fileInput = e.currentTarget;
        var selectedFile = fileInput.files[0];

        if (!selectedFile) {
            self.formData.sampleFile = null;
            self._resetUploadIndicator();
            return;
        }

        if (selectedFile.size > 5 * 1024 * 1024) {
            alert('File must be under 5MB.');
            fileInput.value = '';
            self._resetUploadIndicator();
            return;
        }

        var allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
        if (allowedTypes.indexOf(selectedFile.type) === -1) {
            alert('Only JPG, PNG, or PDF files are supported.');
            fileInput.value = '';
            self._resetUploadIndicator();
            return;
        }

        var reader = new FileReader();
        reader.onload = function () {
            self.formData.sampleFile = {
                fileName: selectedFile.name,
                fileType: selectedFile.type,
                base64Data: reader.result.split(',')[1]
            };
            self._showUploadIndicator(selectedFile.name);
            self._clearGroupError('sampleUpload');
            console.log('[DesignRequest] file loaded into formData:', self.formData.sampleFile.fileName);
        };
        reader.readAsDataURL(selectedFile);
    };

    DesignrequestMainView.prototype._showUploadIndicator = function (fileName) {
        self.$('.design-request-wizard__dropzone').addClass('has-file');
        self.$('.design-request-wizard__dropzone-filename')
            .text(fileName)
            .addClass('is-visible');
    };

    DesignrequestMainView.prototype._resetUploadIndicator = function () {
        self.$('.design-request-wizard__dropzone').removeClass('has-file');
        self.$('.design-request-wizard__dropzone-filename')
            .text('')
            .removeClass('is-visible');
    };

    // ===== PHASE 2: PRINT =====

    DesignrequestMainView.prototype.onWantsPrintChange = function (e) {
        var $el = self.$(e.currentTarget);
        var value = $el.val();
        self.formData.wantsPrint = value;
        console.log('[DesignRequest] wantsPrint changed =', value);
        self._clearFieldError('wantsPrint');
        self._applyWantsPrintVisibility(value);
    };

    DesignrequestMainView.prototype._applyWantsPrintVisibility = function (value) {
        var wantsPrint = value === WANTS_PRINT_YES_ID;
        self.$('.js-print-detail-group').toggleClass('hidden', !wantsPrint);

        if (!wantsPrint) {
            ['printProductType', 'printQuantity', 'printSize', 'printPaper', 'printColorMode', 'printFinish']
                .forEach(function (group) { self._clearGroupError(group); });
        }
    };

    // ===== PHASE 4: PROOF =====

    DesignrequestMainView.prototype._applyProofBranchVisibility = function () {
        var isPrintYes = self.formData.wantsPrint === WANTS_PRINT_YES_ID;
        self.$('.js-proof-branch-yes').toggleClass('hidden', !isPrintYes);
        self.$('.js-proof-branch-no').toggleClass('hidden', isPrintYes);

        var groupsToClear = isPrintYes
            ? ['designFilesApproval']
            : ['proofDelivery', 'disclaimerDigitalProof', 'disclaimerScreenColors',
                'wantsDelivery', 'courierPartner', 'shippingSpeed', 'deliveryAddress'];
        groupsToClear.forEach(function (group) { self._clearGroupError(group); });

        if (isPrintYes) {
            self._applyWantsDeliveryVisibility(self.formData.wantsDelivery);
        }
    };

    DesignrequestMainView.prototype.onWantsDeliveryChange = function (e) {
        var $el = self.$(e.currentTarget);
        var value = $el.val();
        self.formData.wantsDelivery = value;
        console.log('[DesignRequest] wantsDelivery changed =', value);
        self._clearFieldError('wantsDelivery');
        self._applyWantsDeliveryVisibility(value);
    };

    DesignrequestMainView.prototype._applyWantsDeliveryVisibility = function (value) {
        var wantsDelivery = value === WANTS_DELIVERY_YES_ID;
        self.$('.js-delivery-detail-group').toggleClass('hidden', !wantsDelivery);

        if (!wantsDelivery) {
            ['courierPartner', 'shippingSpeed', 'deliveryAddress']
                .forEach(function (group) { self._clearGroupError(group); });
        }
    };

    DesignrequestMainView.prototype._applyDeliveryByDateBounds = function () {
        var bounds = getDeliveryDateBounds();
        self.$('.js-delivery-by')
            .attr('min', formatDateForInput(bounds.min))
            .attr('max', formatDateForInput(bounds.max));
    };

    DesignrequestMainView.prototype.onDeliveryByChange = function (e) {
        var $el = self.$(e.currentTarget);
        var value = $el.val();

        if (value && !isDeliveryDateInRange(value)) {
            $el.val('');
            self.formData.deliveryBy = '';
            self._showGroupError('deliveryBy', getDeliveryDateRangeMessage());
            console.log('[DesignRequest] deliveryBy rejected (out of range):', value);
            return;
        }

        self.formData.deliveryBy = value;
        console.log('[DesignRequest] field changed: deliveryBy =', value);
        self._clearFieldError('deliveryBy');
    };

    // ===== SHARED / VALIDATION =====

    DesignrequestMainView.prototype._clearGroupError = function (group) {
        self.$('[data-group="' + group + '"]')
            .removeClass('has-error')
            .find('.form-group__error')
            .removeClass('is-visible');
    };

    DesignrequestMainView.prototype._clearFieldError = function (formKey) {
        var cfg = FIELD_VALIDATION_CONFIG.filter(function (c) { return c.formKey === formKey; })[0];
        if (cfg) {
            self._clearGroupError(cfg.group);
        }
    };

    DesignrequestMainView.prototype._showGroupError = function (group, message) {
        var $group = self.$('[data-group="' + group + '"]');
        $group.addClass('has-error');
        var $error = $group.find('.form-group__error');
        if (message) {
            $error.text(message);
        }
        $error.addClass('is-visible');
    };

    DesignrequestMainView.prototype.validateForm = function () {
        var firstInvalidEl = null;

        var currentPhaseConfig = FIELD_VALIDATION_CONFIG.filter(function (cfg) {
            return cfg.phase === self.currentPhase;
        });

        currentPhaseConfig.forEach(function (cfg) {
            self._clearGroupError(cfg.group);
        });
        self._clearGroupError('productTypeOther');

        currentPhaseConfig.forEach(function (cfg) {
            if (!cfg.condition(self.formData)) {
                return;
            }

            var value = self.formData[cfg.formKey];

            if (cfg.mustBeTrue) {
                if (isEmptyValue(cfg.type, value)) {
                    self._showGroupError(cfg.group, cfg.requiredMessage);
                    if (!firstInvalidEl) {
                        firstInvalidEl = self.$('[data-group="' + cfg.group + '"]');
                    }
                }
                return;
            }

            var meta = self.fieldMeta ? self.fieldMeta[cfg.metaKey] : null;
            var empty = isEmptyValue(cfg.type, value);

            if (meta && meta.isMandatory && empty) {
                self._showGroupError(cfg.group, cfg.requiredMessage);
                if (!firstInvalidEl) {
                    firstInvalidEl = self.$('[data-group="' + cfg.group + '"]');
                }
                return;
            }

            if (!empty && cfg.formatTest && !cfg.formatTest(value)) {
                var formatMessage = typeof cfg.formatMessage === 'function' ? cfg.formatMessage() : cfg.formatMessage;
                self._showGroupError(cfg.group, formatMessage);
                if (!firstInvalidEl) {
                    firstInvalidEl = self.$('[data-group="' + cfg.group + '"]');
                }
            }
        });

        if (self.currentPhase === 1 &&
            self.formData.needType !== NEED_TYPE_REDESIGN_ID &&
            self.formData.productType === OTHER_PRODUCT_TYPE_ID &&
            isEmptyValue('text', self.formData.productTypeOther)) {
            self._showGroupError('productTypeOther');
            if (!firstInvalidEl) {
                firstInvalidEl = self.$('[data-group="productTypeOther"]');
            }
        }

        if (firstInvalidEl && firstInvalidEl.length) {
            firstInvalidEl[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            return false;
        }

        return true;
    };

    // ===== WIZARD NAVIGATION =====

    DesignrequestMainView.prototype.onPreviousClick = function (e) {
        e.preventDefault();
        if (self.currentPhase === 1) { return; }
        self.currentPhase -= 1;
        console.log('[DesignRequest] moved back to phase', self.currentPhase);
        self._goToPhase(self.currentPhase);
    };

    DesignrequestMainView.prototype.onNextClick = function (e) {
        e.preventDefault();

        if (!self.validateForm()) {
            console.log('[DesignRequest] validation failed on phase', self.currentPhase, '- submit/advance blocked');
            return;
        }

        if (self.currentPhase < TOTAL_PHASES) {
            self.currentPhase += 1;
            console.log('[DesignRequest] advanced to phase', self.currentPhase);
            self._goToPhase(self.currentPhase);
            return;
        }

        self._submitToNetSuite();
    };

    DesignrequestMainView.prototype._goToPhase = function (phaseNumber) {
        self.$('.design-request-wizard__phase').addClass('hidden');
        self.$('.design-request-wizard__phase[data-phase="' + phaseNumber + '"]').removeClass('hidden');

        _updateSteps(phaseNumber);

        self.$('[data-action="previous-phase"]').toggleClass('hidden', phaseNumber === 1);
        self.$('[data-action="next-phase"]').text(phaseNumber === TOTAL_PHASES ? 'Submit' : 'Next');

        if (phaseNumber === 4) {
            self._applyProofBranchVisibility();
            self._applyDeliveryByDateBounds();
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    DesignrequestMainView.prototype._KNOWN_FORM_KEYS = [
        'needType', 'productType', 'productTypeOther', 'brandPersonality', 'styleDirection',
        'styleReference', 'preferredColors', 'preferredFonts', 'competitors', 'staySame',
        'mustChange', 'sampleFile',
        'wantsPrint', 'printProductType', 'printQuantity', 'printSize', 'printPaper',
        'printColorMode', 'printFinish',
        'infoName', 'infoEmail', 'infoPhone', 'infoComments',
        'proofDelivery', 'disclaimerDigitalProof', 'disclaimerScreenColors',
        'disclaimerFinalApproval', 'disclaimerNonRefundable', 'wantsDelivery',
        'courierPartner', 'shippingSpeed', 'deliveryAddress', 'deliveryBy', 'designFilesApproval'
    ];

    DesignrequestMainView.prototype._submitToNetSuite = function () {
        console.log('[DesignRequest] final phase reached, submitting to NetSuite');

        var payload = {};
        self._KNOWN_FORM_KEYS.forEach(function (key) {
            payload[key] = self.formData[key];
        });

        console.log('[DesignRequest] formData being sent:', JSON.stringify(payload));

        self.model.save(payload, {
            type: 'POST',
            success: function (model, response) {
                console.log('[DesignRequest] save SUCCESS callback, raw response:', response);
                if (response && response.success && response.data && response.data.internalId) {
                    self._showSuccessModal();
                } else {
                    console.warn('[DesignRequest] response did not have expected shape:', response);
                    self._showErrorModal();
                }
            },
            error: function (model, xhr) {
                console.error('[DesignRequest] save ERROR callback', xhr);
                self._showErrorModal();
            }
        });
    };

    // ===== SUBMIT RESULT MODALS =====

    DesignrequestMainView.prototype._showSuccessModal = function () {
        self.$('.design-request-wizard__modal-overlay--success').addClass('is-visible');
    };

    DesignrequestMainView.prototype.onSuccessModalClose = function (e) {
        e.preventDefault();
        self.$('.design-request-wizard__modal-overlay--success').removeClass('is-visible');
    };

    DesignrequestMainView.prototype._showErrorModal = function () {
        self.$('.design-request-wizard__modal-overlay--error').addClass('is-visible');
    };

    DesignrequestMainView.prototype.onErrorModalClose = function (e) {
        e.preventDefault();
        self.$('.design-request-wizard__modal-overlay--error').removeClass('is-visible');
    };

    return DesignrequestMainView;
});
